export const ORG_NAME_MAX_LENGTH = 200;

/** Letters, digits, and spaces between words (no special characters). */
export const ORG_NAME_PATTERN = /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/;

export const ORG_NAME_HELPER_TEXT =
  `Letters and numbers only (spaces allowed). Max ${ORG_NAME_MAX_LENGTH} characters.`;

/**
 * @param {string} value
 * @param {string} [fieldLabel]
 * @returns {string|null} Error message or null if valid
 */
export const validateOrgDisplayName = (value, fieldLabel = 'Name') => {
  const normalized = String(value || '').trim();
  if (!normalized) {
    return `${fieldLabel} is required`;
  }
  if (normalized.length > ORG_NAME_MAX_LENGTH) {
    return `${fieldLabel} must be at most ${ORG_NAME_MAX_LENGTH} characters`;
  }
  if (!ORG_NAME_PATTERN.test(normalized)) {
    return `${fieldLabel} may only contain letters, numbers, and spaces`;
  }
  return null;
};
